import { Container } from './styles'

import linkedinIcon from '../../assets/linkedin.png'
import githubIcon from '../../assets/github.png'
import instagramIcon from '../../assets/instagram.png'
import discordIcon from '../../assets/discord.svg'
import WhatsApp from '../../assets/WhatsApp.png'

export function Footer() {
  return (
    <Container className="footer">
      <a href="/" className="logo">
        <span>S</span>
        <span>Tanna</span>
      </a>
      <div>
        <p>
          <span>🤍</span>
        </p>
      </div>

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/sallam-m-tanna-865484144/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedinIcon} alt="Linkedin" />
        </a>

        <a
          href="https://github.com/sallamTanna"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>

        <a
          href="https://wa.me/972598985166"
          target="_blank"
          rel="noreferrer"
        >
          <img src={WhatsApp} alt="Whatsapp" />
        </a>


        <a
          href="https://www.instagram.com/sallam_tanna/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Discord" />
        </a>


        <a
          href="https://discord.gg/Z88u2UCF"
          target="_blank"
          rel="noreferrer"
        >
          <img src={discordIcon} alt="Discord" />
        </a>
      </div>
    </Container>
  )
}
